import React, { Component } from "react";
import AutoComponent from "../common/AutoComponent";
import PageName from "../common/PageName";
import { Button } from "reactstrap";
import { fetchData } from "../common/networkRequests";

const handleSearch = async (current) => {
  let lgs = current.props.liftGlobalState;
  let {
    alerts,
    unsavedChanges,
    errorMessages,
    currentPage,
    pageData, remoteip,
    LocalVars,localpage,
    formElements, notifications,openmodals
  } = current.props.parentState;
  let { token } = current.props.parentProps.parentState;

  if (localpage) {
    currentPage = localpage;
    // console.log(currentPage)
    let modalname=openmodals[openmodals.length-1];
    if(modalname && pageData[modalname]){
      pageData=pageData[modalname]
    }
    // pageData=pageData[openmodals]
    // if(openmodals[openmodals.length-1]){
    //   let modalname=openmodals[openmodals.length-1]
    //   // console.log(openmodals[openmodals.length-1])
    //   pageData=pageData[modalname]
    // }
   
  }

  // console.log({currentPage,pageData})
  
  let searchThis = { currentPage, pageData, dataType: "search" };

  // console.log("search clicked")

  let shouldProceed = true;
  let errors = [];
  current.setState({ isSearch: true });
  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let method = 'post';

  // current.props.liftGlobalState({ name: 'notifications' }, notifications);
  let response = await fetchData({ url, postData: searchThis, method, headers: { Authorization: `JWT ${token}` } });
  
  let { results, exceptions, error }=response;
  if (response == 'jwt expired' || response == 'jwt malformed') {
    notifications = { value: "Session expired", alertType: "warning" };
    lgs({ name: 'notifications' }, notifications);
    setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
  }
  else if (error) {
    notifications = { value: "Can not connect to the main server", alertType: "warning" };
    current.props.liftGlobalState({ name: 'notifications' }, notifications);
    current.setState({ isSearch: false });
  }else if(exceptions && Object.keys(exceptions).length >0){
    let errorM = exceptions.message
     if(errorM.includes("The user has been logged off.")==true){
        setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
      }
  }
  else {
    let { LocalVars } = current.props.parentState;
    LocalVars["ShowHistory"] = true;
    current.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
    current.setState({ isSearch: false });
    // if (Object.keys(results).length > 0) {
    //   current.setState({ isSearch: true });
    // }
    let reportData = []
    for (var k in results) {
      reportData.push(results[k])
    }

    current.props.liftGlobalState({ name: 'notifications' }, []);
    // convert to relevant format.
   
    if (localpage) {
      current.props.liftGlobalState({ name: 'OriginalDataOther' }, { [localpage]: reportData });
    } else {
      current.props.liftGlobalState({ name: 'OriginalData' }, reportData);
    }

  }
  // current.props.liftGlobalState(
  //   { name: "ShowSidebar" },
  //   current.props.parentState.ShowSidebar
  // );

}

class PushkarFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { isSearch: false };

  }

  handleFilter = () => {
    let { LocalVars, pageData, ShowSidebar } = this.props.parentState;
    // console.log(ShowSidebar)
    LocalVars["showFilter"] = false;
    LocalVars["ShowHistory"] = false;
    this.props.liftGlobalState(
      { name: "ShowSidebar" },
      false
    );
    this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
    this.props.liftGlobalState({ name: "pageData" }, {});
  };


  createComponent = (allc, localpage) => {
    let { currentWizard, showFilter } = this.props.parentState.LocalVars;
    let { fileFolder, showButtons, formElements, currentPage,themecolor } = this.props.parentState;
    let x;
    !themecolor ? themecolor = "default" : x = 0;
    return (
      <div className="col-12 noprint" id="formcontentheight">
        {!localpage &&
          <PageName
            className="row"
            parentState={this.props.parentState}
            liftGlobalState={this.props.liftGlobalState}
            liftState={this.props.liftState}
            parentProps={this.props.parentProps}
          />
        }
        <div
          style={{ marginTop: 0 }}
          className={`SearchArea form-section ${themecolor}-form-section ${
            this.props.parentState.LocalVars.formSubmittedClass
            }`}
        >
          {/* {formElements[currentPage].form.length > 0 && !localpage &&
            <Button
              outline
              id="createButton"
              style={{ marginBottom: 5 }}
              onClick={this.handleFilter}
              size="sm" color="success" 
            >
              Create
          </Button>
          } */}

          <div
            style={{
              marginRight: 0,
              paddingRight: 0,
              marginLeft: 0,
              paddingLeft: 0
            }}
            className="row col-sm-12 sub-form-section">
            {allc.map((component, index) => {
              let conditionalRender = 'no';
              // Check if contains subComponents.
              if (component.subComponents) {
                return (
                  <div key={index} className={`nopadding ${component.widths}`}>
                    {this.createComponent(component.subComponents)}
                  </div>
                );
              } else {
                let shouldRender = 1;
                if (component.parents) {
                  for (let i = 0; i < component.parents.length; i++) {
                    let elem = component.parents[i];
                    const parentVal = this.props.parentState.pageData[
                      elem.name
                    ];
                    if (
                      elem.reverse &&
                      ((elem.match === "exist" && parentVal) ||
                        (elem.match === "value" && parentVal == elem.value))
                    ) {
                      shouldRender = 0;
                    } else if (
                      !elem.reverse &&
                      ((elem.match === "exist" && parentVal) ||
                        (elem.match === "value" && parentVal == elem.value))
                    ) {
                      shouldRender = 1;
                    } else if (
                      !elem.reverse &&
                      ((elem.match === "exist" && parentVal) ||
                        (elem.match === "in" &&
                          elem.value.indexOf(parentVal) != -1))
                    ) {
                      shouldRender = 1;
                    } else {
                      if (!elem.reverse) {
                        shouldRender = 0;
                      }
                    }
                    if (shouldRender == 0 && elem.show && (elem.show == 'blank' || elem.show == 'readonly')) {
                      shouldRender = 1;
                      conditionalRender = elem.show;
                    }
                  }
                }

                // shouldRender = 0 for all components where wizard != currentWizard
                // wizard && component.wizard && component.wizard != currentWizard
                //   ? (shouldRender = 0)
                //   : null;

                if (shouldRender == 1) {
                  if (
                    this.props.parentState &&
                    this.props.parentState.pageData[component.name]
                  ) {
                    var value = this.props.parentState.pageData[component.name];
                  } else {
                    var value = "";
                  }

                  return (
                    <AutoComponent
                      component={component}
                      liftState={this.props.liftState}
                      liftGlobalState={this.props.liftGlobalState}
                      parentStateGlobal={this.props.parentState}
                      parentState={this.props.parentState}
                      parentProps={this.props.parentProps}
                      key={index}
                      index={index}
                      conditionalRender={conditionalRender}
                    />
                  );
                }
              }
            })}
          </div>
          {(showButtons.search || localpage) &&
            (<div className="row">
              {!this.state.isSearch && <Button
                outline
                className={`col-2 offset-5 black-submit-button`}
                id="main-form-submit-button"
                color="success"
                onClick={()=>handleSearch(this)}
              >
                <span>Search</span>
              </Button>}

              {this.state.isSearch &&
                <div className="col-2 offset-5"> 
                 <img height="50" width="50" src="/images/gif/spinner-min.gif" /></div>
              }
            </div>)
          }
        </div>
      </div>
    );
  };

  render() {
    let {
      fileFolder,
      formState,
      otherPage, showButtons, LocalVars,
      localpage,
      currentPage
    } = this.props.parentState;
    if (localpage) {
      currentPage = localpage;
    }

    // var currentPage = this.props.parentState.currentPage.toLowerCase();

    let { filter } = this.props.parentState.formElements[currentPage];
    let stat = [{
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Convert currency",
      label: "Convert currency",
      description: "Convert currency"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Unit",
          value: "ones"
        },
        {
          label: "Thousands",
          value: "thousands"
        },
        {
          label: "Lakhs",
          value: "lakhs"
        },
        {
          label: "Crores",
          value: "crores"
        }
      ],
      placeHolder: "Currency Convert",
      //   label: "Branch Code",
      name: "currency_convert",
      description: "Convert currency"
    }];
    // 
    // if(!localpage){
    //   filter = filter.concat(stat);
    // }

    return this.createComponent(filter, localpage);
  }
}

export default PushkarFilter;